<template>
    <div class="app-sidenav">
        <span class="app-topnav__menu-icon--close">
            <common-icon name="close" size="medium" @click="emitEvent({ name: 'toggle-sidenav' })"></common-icon>
        </span>
        <router-link :to="{ name: 'index' }" class="app-sidenav__logo">
            <svg>
                <use xlink:href="#picture-logo-white" />
            </svg>
        </router-link>

        <div v-if="showUserContext" class="app-sidenav__user-context">
            <app-user-context></app-user-context>
        </div>
        <div v-else class="app-sidenav__user-context">
            <div class="app-user-context">
                <p class="app-user-context__name">
                    {{ $auth.getPractice().name ?? $auth.getUser().practiceName }}
                </p>
            </div>
        </div>

        <div class="app-sidenav__main-menu">
            <app-main-menu @open-paywall-modal="openPaywallModal"></app-main-menu>
        </div>
        <div v-if="$auth.isActiveMemberPhysician()" class="app-sidenav__notification">
            <app-notification></app-notification>
        </div>
    </div>
</template>

<script>
    import UserRolesEnum from 'enums/UserRolesEnum'
    import AppMainMenu from 'components/layouts/app-layout/AppMainMenu'
    import AppUserContext from 'components/layouts/app-layout/AppUserContext'
    import AppNotification from 'components/layouts/app-layout/AppNotification'

    export default {
        components: {
            AppMainMenu,
            AppUserContext,
            AppNotification,
        },

        data() {
            return {
                UserRolesEnum: UserRolesEnum,
            }
        },

        computed: {
            showUserContext() {
                return !this.$auth.isUserOnlyPhysician() && this.$auth.isActiveMemberPhysician()
            },
        },

        methods: {
            openPaywallModal() {
                this.emitEvent({ name: 'open-paywall-modal' })
            },
        },
    }
</script>
